import { BonusType, Bonus } from '~/bonus/model/bonus.model'

export function totalRecurringFee(bonusType: BonusType) {
  const totalFee = bonusType.duration
    ? bonusType.duration * bonusType.recurringFee?.valueWithTax
    : bonusType.recurringFee?.valueWithTax

  return totalFee || 0
}

export function totalFixedFees(bonusType: BonusType) {
  const initialFee = bonusType.initialFee?.valueWithTax || 0
  const finalFee = bonusType.finalFee?.valueWithTax || 0
  return initialFee + finalFee
}

export function getBonusTypeById(bonusTypes: BonusType[], bonusId: string) {
  return bonusTypes.filter((bonusType) => bonusType.id === bonusId)[0]
}

export const isUnlimitedVoiceTariff = (bonuses?: Bonus[]) =>
  bonuses?.some((subs) => subs.bonusType.type === 'VOICE' && subs.bonusType.isUnlimitedDuration)

export const isUnlimitedDataTariff = (bonuses?: Bonus[]) =>
  bonuses?.some((subs) => subs.bonusType.type === 'DATA' && subs.bonusType.isUnlimitedAmount)

export const totalVoiceInTariff = (bonuses?: Bonus[]) =>
  (bonuses && totalVoiceSubscription(bonuses)) || 0

export const totalDataInTariff = (bonuses?: Bonus[]) =>
  (bonuses && totalDataSubscription(bonuses)) || 0

export const dataSubscriptionTariff = (bonuses: Bonus[]) =>
  bonusesInTariff(bonuses)
    .filter((elem) => elem.bonusType.type === 'DATA')
    .reduce((acum, elem) => Number(elem.bonusType.amountPerPeriod.value) + acum, 0)

export const bonusesInTariff = (bonuses: Bonus[]) =>
  bonuses?.filter((bonus) => bonus.bonusType.isMandatory)

export const getBonusesOutOfTariff = (bonuses: Bonus[]) =>
  bonuses?.filter((bonus) => !bonus.bonusType.isMandatory)

export const voiceSubscriptionTariff = (bonuses: Bonus[]) =>
  bonusesInTariff(bonuses)
    .filter((elem) => elem.bonusType.type === 'VOICE')
    .reduce((acum, elem) => Number(elem.bonusType.amountPerPeriod.value) + acum, 0)

export const totalDataSubscription = (bonuses: Bonus[]) =>
  bonuses
    .filter((elem) => elem.bonusType.type === 'DATA')
    .reduce((acum, elem) => Number(elem.bonusType.amountPerPeriod.value) + acum, 0)

export const totalVoiceSubscription = (bonuses: Bonus[]) =>
  bonuses
    .filter((elem) => elem.bonusType.type === 'VOICE')
    .reduce((acum, elem) => Number(elem.bonusType.amountPerPeriod.value) + acum, 0)
